module.exports = __webpack_public_path__ + "987bb8c981299f339c4607d06ba3ef44.pdf";